<template>
    <div style="display: inline-block;">
        <span @click.stop="showView">
            <slot></slot>
        </span>

        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="$style.dialog"
            title="修改商品提成信息"
        >
        <!-- <p @click="fang()">刷新</p> -->
            <pro-optionss
                :type="1"
                :list="list"
                :goods_id="goods_id"
                :lowest_rate="lowest_rate"
                :lowest_price="lowest_price"
                :beyond_rate="beyond_rate"
                :getCartProducts="getCartProducts"
                :fang = "fang"
                :visible.sync="visible"
            ></pro-optionss>
        </el-dialog>
    </div>
</template>
<script>
    import Vue from 'vue';
    import ProOption from '../../components/Common/GoodsDs';

    Vue.component('pro-optionss', ProOption);
    export default {
        props: ['goods_attr_list', 'goods_id', 'getCartProducts','lowest_price','lowest_rate','beyond_rate','getProducts'],

        data () {
            return {
                order_id:localStorage.getItem('order_id'),
                visible: false,
                // list: (this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
                list:(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
            };

        },
        methods:{
            // fang(){

            //      this.list=(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
            //     console.log(this.goods_attr_list);
            //     },

                showView(){
                 this.visible=true;
                 this.list=(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
                }
        },
        // mounted(){
        //     this.fang()
        // }

    };


</script>

<style lang="less" module>
    .dialog {
        width: 600px;
        :global(.el-dialog__header) {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        :global(.el-dialog__body) {
            padding: 30px 90px 30px 70px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/GoodsSetups/Dialogs.vue